import { c as _c } from "react/compiler-runtime";
import type { JsxStyleProps } from '@repo/pandacss/types';
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { CTASearchParams, type SearchParamValue } from '@repo/platform-analytics/lib/ctaSearchParams';
import { FinishType } from '@repo/platform-analytics/types';
import { MaskIcon } from '@repo/ui/primitives/MaskIcon';
import { type CtaAnalyticsProps, CtaLink } from '../CTA/CtaLink';
type RatesAndFeesLinkProps = {
  href: string;
  analytics: CtaAnalyticsProps;
  versionId: number;
  additionalParams?: Record<string, SearchParamValue>;
  children?: React.ReactNode;
  showBlankTargetIcon?: boolean;
  onClickAnalyticsCallback?: () => void;
  containerCssProps?: JsxStyleProps['css'];
  name: string;
};
export const RatesAndFeesLink = t0 => {
  const $ = _c(18);
  const {
    href,
    analytics,
    children,
    additionalParams,
    showBlankTargetIcon,
    onClickAnalyticsCallback,
    containerCssProps,
    name
  } = t0;
  const {
    shoppingFinishedId
  } = useAnalyticsSkuViewedContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "[0.7125rem]",
      _pcMd: "[0.75rem]"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== containerCssProps) {
    t2 = {
      textAlign: "center",
      fontSize: t1,
      ...containerCssProps
    };
    $[1] = containerCssProps;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = analytics.monetizable ?? "";
  let t4;
  if ($[3] !== additionalParams || $[4] !== t3) {
    t4 = [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH, {
      replacements: {
        cta_type: "RATES_AND_FEES_TEXT",
        monetizable: t3,
        ...additionalParams
      }
    }];
    $[3] = additionalParams;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `View rates and fees for ${name}`;
  const t6 = children ? children : "Rates & Fees";
  let t7;
  if ($[6] !== showBlankTargetIcon) {
    t7 = showBlankTargetIcon && <MaskIcon glyph="open-in-new" size="sm" css={{
      ml: "2",
      verticalAlign: "sub"
    }} />;
    $[6] = showBlankTargetIcon;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== analytics || $[9] !== href || $[10] !== onClickAnalyticsCallback || $[11] !== shoppingFinishedId || $[12] !== t2 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <CtaLink analytics={analytics} type="RATES_AND_FEES_TEXT" href={href} finishType={FinishType.ExternalApplication} onClickAnalyticsCallback={onClickAnalyticsCallback} rel="nofollow" target="_blank" underline="hover" css={t2} parameterActions={t4} aria-label={t5} shoppingFinishedId={shoppingFinishedId}>{t6}{t7}</CtaLink>;
    $[8] = analytics;
    $[9] = href;
    $[10] = onClickAnalyticsCallback;
    $[11] = shoppingFinishedId;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};